import React, {useContext,useState} from 'react';
import {YearContext} from '../../contexts/yearContext';
import {flashPrintBlocked, openPrintRoute} from '../prints/parity/AriaReport';
import PrintIcon from '../../icons/print-icon';

export default function DailyAttendanceReport({kind,date,disabled}) {
  const {entryYear}=useContext(YearContext) || {};
  const [error,setError]=useState('');
  const run=()=>{
    const kindPath=kind==='teachers'?'teacher-attendance':'staff-attendance';
    const path=`/print/${kindPath}/${date}?entryYearId=${entryYear || ''}`;
    if(!openPrintRoute(path)) flashPrintBlocked(setError);
  };
  return (
    <span className="attendance-daily-print">
      <button
        type="button"
        className="circle print"
        title="چاپ گزارش روزانه و خلاصه"
        aria-label="چاپ گزارش روزانه و خلاصه"
        disabled={disabled || !entryYear}
        onClick={run}
      >
        <PrintIcon />
      </button>
      {error ? <span role="alert">{error}</span> : null}
    </span>
  );
}
